import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/apps/incluipcd/src/blocks/Empresas/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/apps/incluipcd/src/blocks/Empresas/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/apps/incluipcd/src/blocks/Empresas/Pricing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/apps/incluipcd/src/blocks/Empresas/WhyChooseUs.tsx");
